<app-anonymous-page-layout>
  <app-card>
    <app-page-title
      [title]="'PAGE.TERMS_CONDITIONS.TITLE' | translate"
      style="--page-title-padding-bottom: var(--size-xl)"
    ></app-page-title>
    {{ 'PAGE.TERMS_CONDITIONS.TEXT' | translate }}
  </app-card>
</app-anonymous-page-layout>
